// frontend/src/main.tsx
import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./context/auth-context";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

// i18n initialization (synchronous because resources are imported)
import "./i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import App from "./app";

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <App />
        <Analytics />
        <SpeedInsights />
      </AuthProvider>
    </I18nextProvider>
  </React.StrictMode>
);